<template>
  <v-row class="mt-10 default-years">
    <!-- BLUE -->
    <v-col
      cols="12"
      md="4"
      class="course-container"
      :class="{
        disabled:
          !requiredLanguage ||
          checkIfCourseExists('blueYear') ||
          checkIfAdminCourseBaseExists('blueYear') ||
          listDefaultBlue.length === 0,
      }"
    >
      <v-card
        width="150"
        height="150"
        class="blueyear rounded-circle d-inline-flex justify-center align-center"
        elevation="0"
        :disabled="
          !requiredLanguage ||
          checkIfCourseExists('blueYear') ||
          checkIfAdminCourseBaseExists('blueYear') ||
          listDefaultBlue.length === 0
        "
        @click="defaultSections('blueYear')"
      >
        <span class="text-white text-uppercase font-weight-bold">{{
          $t('courses.blueYear')
        }}</span>
      </v-card>

      <v-card-text class="px-0">
        <div class="text-subtitle-2 text-uppercase font-weight-bold">
          {{ $t('courses.sectionsOfBlueYear') }}
        </div>

        <div v-if="requiredLanguage" class="text-caption mt-1">
          {{ requiredLanguage.toUpperCase() }}: {{ listDefaultBlue.length }}
        </div>

        <!-- compact list (no v-list-item-title) -->
        <div class="default-sections-list">
          <span
            v-for="section in listDefaultBlue"
            :key="section.id"
            class="section-line"
          >
            {{ $helpers.uppercase(section.title) }}
            <v-icon
              v-if="section.locked || section.superLocked"
              class="default-list-lock"
              :icon="'$lock'"
            />
          </span>
        </div>
      </v-card-text>
    </v-col>

    <!-- GREEN -->
    <v-col
      cols="12"
      md="4"
      class="course-container"
      :class="{
        disabled:
          !requiredLanguage ||
          checkIfCourseExists('greenYear') ||
          checkIfAdminCourseBaseExists('greenYear') ||
          listDefaultGreen.length === 0,
      }"
    >
      <v-card
        width="150"
        height="150"
        class="greenyear rounded-circle d-inline-flex justify-center align-center"
        elevation="0"
        :disabled="
          !requiredLanguage ||
          checkIfCourseExists('greenYear') ||
          checkIfAdminCourseBaseExists('greenYear') ||
          listDefaultGreen.length === 0
        "
        @click="defaultSections('greenYear')"
      >
        <span class="text-white text-uppercase font-weight-bold">{{
          $t('courses.greenYear')
        }}</span>
      </v-card>

      <v-card-text class="px-0">
        <div class="text-subtitle-2 text-uppercase font-weight-bold">
          {{ $t('courses.sectionsOfGreenYear') }}
        </div>

        <div v-if="requiredLanguage" class="text-caption mt-1">
          {{ requiredLanguage.toUpperCase() }}: {{ listDefaultGreen.length }}
        </div>

        <div class="default-sections-list">
          <span
            v-for="section in listDefaultGreen"
            :key="section.id"
            class="section-line"
          >
            {{ $helpers.uppercase(section.title) }}
            <v-icon
              v-if="section.locked || section.superLocked"
              class="default-list-lock"
              :icon="'$lock'"
            />
          </span>
        </div>
      </v-card-text>
    </v-col>

    <!-- RED -->
    <v-col
      cols="12"
      md="4"
      class="course-container"
      :class="{
        disabled:
          !requiredLanguage ||
          checkIfCourseExists('redYear') ||
          checkIfAdminCourseBaseExists('redYear') ||
          listDefaultRed.length === 0,
      }"
    >
      <v-card
        width="150"
        height="150"
        class="redyear rounded-circle d-inline-flex justify-center align-center"
        elevation="0"
        :disabled="
          !requiredLanguage ||
          checkIfCourseExists('redYear') ||
          checkIfAdminCourseBaseExists('redYear') ||
          listDefaultRed.length === 0
        "
        @click="defaultSections('redYear')"
      >
        <span class="text-white text-uppercase font-weight-bold">{{
          $t('courses.redYear')
        }}</span>
      </v-card>

      <v-card-text class="px-0">
        <div class="text-subtitle-2 text-uppercase font-weight-bold">
          {{ $t('courses.sectionsOfRedYear') }}
        </div>

        <div v-if="requiredLanguage" class="text-caption mt-1">
          {{ requiredLanguage.toUpperCase() }}: {{ listDefaultRed.length }}
        </div>

        <div class="default-sections-list">
          <span
            v-for="section in listDefaultRed"
            :key="section.id"
            class="section-line"
          >
            {{ $helpers.uppercase(section.title) }}
            <v-icon
              v-if="section.locked || section.superLocked"
              class="default-list-lock"
              :icon="'$lock'"
            />
          </span>
        </div>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
  import db from '@/firebase/init'

  export default {
    name: 'DefaultCourses',
    props: [
      'isAuthenticated',
      'sections',
      'courses',
      'courseToEdit',
      'requiredLanguage',
    ],
    data() {
      return {
        feedback: null,
        selectedSections: [],
        list: [],
        baseYear: '',
        basecourses: [],
        years: { blueYear: null, greenYear: null, redYear: null },
        admins: [],
        computeYearsToken: 0,
        coursesWatchTimer: null,
      }
    },
    computed: {
      listDefaultBlue() {
        return this.buildYearSectionList(this.getYearSectionRefs('blueYear'))
      },
      listDefaultGreen() {
        return this.buildYearSectionList(this.getYearSectionRefs('greenYear'))
      },
      listDefaultRed() {
        return this.buildYearSectionList(this.getYearSectionRefs('redYear'))
      },
    },
    watch: {
      courses: {
        handler() {
          if (this.coursesWatchTimer) {
            clearTimeout(this.coursesWatchTimer)
          }
          this.coursesWatchTimer = setTimeout(() => {
            this.coursesWatchTimer = null
            this.computeYears()
          }, 100)
        },
        deep: true,
        immediate: true,
      },
    },
    beforeUnmount() {
      if (this.coursesWatchTimer) {
        clearTimeout(this.coursesWatchTimer)
      }
    },
    methods: {
      getYearSectionRefs(year) {
        const yearData = this.years[year]
        if (!yearData) return null
        // Leaders: sections keyed by requiredLanguage; admins: flat array from base courses
        if (Array.isArray(yearData)) return yearData
        const lang = (this.requiredLanguage || 'en').toLowerCase()
        return yearData[lang] || null
      },
      resolvedAllYears() {
        return {
          blueYear: this.getYearSectionRefs('blueYear') || [],
          greenYear: this.getYearSectionRefs('greenYear') || [],
          redYear: this.getYearSectionRefs('redYear') || [],
        }
      },
      /**
       * Do not mutate parent `sections` inside computeds — writing reactive
       * fields during computed evaluation can retrigger the same computeds
       * indefinitely and freeze the UI.
       */
      buildYearSectionList(yearArr) {
        if (!yearArr?.length || !this.sections?.length) return []

        const rows = []
        for (const item of this.sections) {
          const idx = yearArr.findIndex((u) => u.id === item.id)
          if (idx < 0) continue
          const meta = yearArr[idx]
          rows.push({
            ...item,
            locked: !!meta.locked,
            superLocked: !!meta.superLocked,
            order: idx,
          })
        }

        let filtered = this.requiredLanguage
          ? rows.filter(
              (section) =>
                section.requiredLanguage === this.requiredLanguage ||
                (!section.requiredLanguage && this.requiredLanguage === 'en')
            )
          : rows

        filtered = [...filtered].sort(
          (a, b) => (a.order ?? 0) - (b.order ?? 0)
        )
        return filtered
      },

      async computeYears() {
        const token = ++this.computeYearsToken
        const roles = this.$store.getters['UserData/getRoles'] || []
        const isSuperAdmin =
          roles.includes('superAdmin') || roles.includes('helpDesk')
        const isAdmin = roles.includes('admin')
        const isLeader = roles.includes('leader')

        if (isSuperAdmin || isAdmin) {
          const snap = await db
            .collection('courses')
            .where('base', '==', true)
            .get()
          if (token !== this.computeYearsToken) return

          const bases = []
          snap.forEach((doc) => bases.push({ id: doc.id, ...doc.data() }))
          const years = bases.reduce((acc, c) => {
            acc[c.baseYear] = c.sections || []
            return acc
          }, {})
          this.years = {
            blueYear: years.blueYear || null,
            greenYear: years.greenYear || null,
            redYear: years.redYear || null,
          }
          return
        }

        if (isLeader) {
          const admins = []
          const usersRef = db
            .collection('users')
            .where('cid', '==', this.$store.getters['AppData/cid'])
            .where('roles', 'array-contains', 'admin')
          const uSnap = await usersRef.get()
          if (token !== this.computeYearsToken) return

          uSnap.forEach((d) => admins.push(d.data().uid))

          const active = (this.courses || []).filter(
            (c) =>
              !c.archive &&
              (c.selectedGroup || []).length === 0 &&
              admins.includes(c.createdBy)
          )
          const years = {}
          active.forEach((c) => {
            if (!c.baseYear) return
            const lang = (c.requiredLanguage || 'en').toLowerCase()
            if (!years[c.baseYear]) years[c.baseYear] = {}
            years[c.baseYear][lang] = c.sections || []
          })
          this.years = {
            blueYear: years.blueYear || null,
            greenYear: years.greenYear || null,
            redYear: years.redYear || null,
          }
        }
      },

      defaultSections(year) {
        this.baseYear = year
        const yearRefs = this.getYearSectionRefs(year)
        if (!yearRefs?.length) return

        const selected = this.sections.filter((item) => {
          const found = yearRefs.find((u) => u.id === item.id)
          if (found) {
            item.locked = !!found.locked
            item.superLocked = !!found.superLocked
            return true
          }
          return false
        })

        selected.forEach((s) => {
          s.order = yearRefs.findIndex((u) => u.id === s.id)
        })
        selected.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

        this.selectedSections = selected

        this.list = this.sections
          .filter((el) => !this.selectedSections.some((s) => s.id === el.id))
          .map((i) => ({ ...i, locked: false, superLocked: false }))

        this.$emit('listevent', {
          list: this.list,
          selectedSections: this.selectedSections,
          baseYear: this.baseYear,
          allYears: this.resolvedAllYears(),
        })
      },

      checkIfCourseExists(year) {
        const user = this.$store.getters['UserData/getUser']
        const roles = this.$store.getters['UserData/getRoles'] || []
        if (
          !user ||
          roles.includes('superAdmin') ||
          roles.includes('helpDesk')
        )
          return false

        if (!this.requiredLanguage) return false

        const normalizedLang = (this.requiredLanguage || 'en').toLowerCase()

        if (roles.includes('admin')) {
          return (this.courses || []).some((c) => {
            if (c.archive) return false
            if (c.createdBy !== user.uid) return false
            if ((c.selectedGroup || []).length > 0) return false
            const courseLang = (c.requiredLanguage || 'en').toLowerCase()
            return c.baseYear === year && courseLang === normalizedLang
          })
        }

        if (roles.includes('leader')) {
          return (this.courses || []).some(
            (c) => !c.archive && c.baseYear === year && c.createdBy === user.uid
          )
        }

        return false
      },

      checkIfAdminCourseBaseExists(year) {
        const user = this.$store.getters['UserData/getUser']
        const roles = this.$store.getters['UserData/getRoles'] || []
        const isAdminish =
          roles.includes('superAdmin') ||
          roles.includes('helpDesk') ||
          roles.includes('admin')
        if (!user || !isAdminish) return false

        if (!this.requiredLanguage) return false

        const normalizedLang = (this.requiredLanguage || 'en').toLowerCase()

        return (this.courses || []).some((c) => {
          if (c.archive) return false
          if (c.baseYear !== year) return false
          const courseLang = (c.requiredLanguage || 'en').toLowerCase()
          if (courseLang !== normalizedLang) return false
          return (c.selectedGroup || []).length === 0
        })
      },
    },
    async created() {
      await this.computeYears()

      // Automatically trigger defaultSections in edit mode
      if (this.courseToEdit && this.courseToEdit.baseYear) {
        const baseYear = this.courseToEdit.baseYear
        if (this.getYearSectionRefs(baseYear)?.length) {
          this.defaultSections(baseYear)
        }
      }
    },
  }
</script>

<style scoped>
  .course-container.disabled {
    opacity: 0.35;
  }
  .default-list-lock {
    max-width: 10px;
  }
  /* smaller, tight lines like the Vue 2 look */
  .default-sections-list .section-line {
    display: block;
    font-size: 13px;
    line-height: 1.25;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    margin: 2px 0;
  }
  .default-list-lock {
    font-size: 12px;
    margin-left: 6px;
    vertical-align: middle;
  }
</style>
